export default {
  BASE: 'base',
  PROMO: 'promo'
}
